﻿/**
* DevExpress Analytics (query-builder\binding\eventGenerator.js)
* Version:  21.2.7
* Build date: Apr 13, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localization = require("devextreme/localization");
var localization_1 = require("../../property-grid/localization/localization");
var EventGenerator = (function () {
    function EventGenerator() {
    }
    EventGenerator.generateQueryBuilderEvents = function (fireEvent) {
        function customizeActions(actions) {
            fireEvent('CustomizeMenuActions', {
                Actions: actions,
                GetById: function (actionId) {
                    return actionId ? actions.filter(function (item) { return actionId === item.id; })[0] : null;
                }
            });
        }
        function customizeLocalization(localizationCallbacks) {
            fireEvent('CustomizeLocalization', {
                LoadMessages: function (messages) {
                    if (!messages)
                        return;
                    if (typeof messages.then === 'function') {
                        localizationCallbacks.push(messages);
                    }
                    else {
                        localization_1.loadMessages(messages);
                    }
                },
                WidgetLocalization: localization
            });
        }
        function onServerError(args) {
            fireEvent('OnServerError', { Error: args });
        }
        function beforeRender(designerModel) {
            fireEvent('BeforeRender', designerModel);
        }
        function saveQueryRequested(queryModel) {
            fireEvent('SaveQueryRequested', queryModel);
        }
        return {
            beforeRender: beforeRender,
            saveQueryRequested: saveQueryRequested,
            customizeActions: customizeActions,
            customizeLocalization: customizeLocalization,
            onServerError: onServerError
        };
    };
    return EventGenerator;
}());
exports.EventGenerator = EventGenerator;
